import React, {useState} from "react";
import {useForm} from "react-hook-form";
import AddressFields from "./AddessFields";

export default function () {
  const {register, handleSubmit, reset, control, watch} = useForm();
  const [errors, setErrors] = useState({});
  const [data, setData] = useState({});
  const addressFields = <AddressFields {...{register, errors, control, watch, data}} />;

  return {
    setErrors,
    addressFields,
    handleSubmit,
    setData,
    reset,
  }
}